import { useState, useEffect } from "react";  
import { axios_helper_no_header } from "../../../common_nextgen/axios/AxiosHelper";   
import { useToast } from "../../../common_nextgen/hooks/ToastContext";  
import getBackendUrl from "../../../environment/BackendService";  
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";

  
const usePriceScheduleNotes = (selectedPriceSchedules, initialIndex, currentMode) => {  
    const [notes, setNotes] = useState([]);  
    const [newNotes, setNewNotes] = useState([""]);  
    const [mode, setMode] = useState("view"); // 'view' or 'add'  
    const [first, setFirst] = useState(0);  
    const [rows, setRows] = useState(10);  
    const [totalRecords, setTotalRecords] = useState(0);  
    const [currentIndex, setCurrentIndex] = useState(initialIndex);  
    const toast = useToast();  
  
    const initializeProgram = async () => {  
        const page = first / rows;  
        try {  
            if (mode === 'view') {  
                const prcName = selectedPriceSchedules[currentIndex];  
                const params = {  
                    prcPriceScheduleName: prcName,  
                    page: page,  
                    size: rows  
                };  
                const notesResponse = await axios_helper_no_header(  
                    "GET",  
                    "api/priceschedule/note",  
                    {},  
                    params  
                );  
                setNotes(notesResponse.responseData.reverse());  
                setTotalRecords(notesResponse.responsePaginationDTO.totalRecords);  
                if (notesResponse.responsePaginationDTO.totalRecords === 0) {  
                    setMode("add");  
                }  
            }  
        } catch (error) {  
            console.error("Initialization failed:", error);  
        }  
    };  
  
    useEffect(() => {  
        initializeProgram();  
    }, [first, rows, currentIndex, selectedPriceSchedules, mode]);  
  
    useEffect(() => {  
        setNewNotes(Array(rows).fill(''));  
        setFirst(0);  
    }, [mode, rows]);  
  
    const handleSaveNotes = async (formData) => {  
        try {  
            const updatedNotes = formData  
                .filter((note) => String(note).trim() !== "")  
                .map((note) => ({  
                    prcPriceScheduleName: selectedPriceSchedules[currentIndex],  
                    psnNote: note,  
                    screenNumber: "RCPSN001"  
                }));  
  
            const response = await axios_helper_no_header(  
                "POST",  
                "api/priceschedule/note/create",  
                updatedNotes,  
                {}  
            );  
  
            setNotes([...updatedNotes, ...notes]);  
            setNewNotes([""]);  
            setMode("view");  
        } catch (error) {  
            console.error("Save notes failed:", error);  
            toast.current.show({  
                severity: "error",  
                summary: "",  
                detail: error.message,  
                life: 3000,  
            });  
        }  
    };  
  
    const handleChangeNewNote = (index, value) => {  
        const updatedNotes = [...newNotes];  
        updatedNotes[index] = value;  
        setNewNotes(updatedNotes);  
    };  
  
    const onPageChange = (event) => {  
        setFirst(event.first);  
        setRows(event.rows);  
        setNewNotes(Array(rows).fill(''));  
    };  

    const exportAsCSV = async () => {
        let params = {  
            prcPriceScheduleName: selectedPriceSchedules[currentIndex]  
        };  
        const queryParams = new URLSearchParams({ ...params });  
        try {
          const response = await axios_helper_no_header(
            "GET",
            "api/priceschedule/note/exportcsv",
            null,
            queryParams,
            "blob"
          );
          downloadCSV(response);
        } catch (error) {
          console.error("Error exporting as CSV:", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: "Failed to export CSV. Please try again.",
            life: 3000,
          });
        }
      };
  
    return {  
        notes,  
        newNotes,  
        mode,  
        first,  
        rows,  
        totalRecords,  
        currentIndex,  
        setMode,  
        setFirst,  
        setRows,  
        setCurrentIndex,  
        handleSaveNotes,  
        handleChangeNewNote,  
        onPageChange,  
        exportAsCSV  
    };  
};  
  
export default usePriceScheduleNotes;  
